import { z } from 'zod';
import { defineEndpoint } from '../define';
import { UserEmailInputSchema, UserEmailSchema } from './shapes';

export const CreateUserEmailBodySchema = z.object({ email: UserEmailInputSchema }).strict();
export type CreateUserEmailBody = z.infer<typeof CreateUserEmailBodySchema>;

// 409 `email_already_registered` when the email matches any user's primary or
// additional email (including the caller's own primary).
export const createUserEmail = defineEndpoint({
  method: 'POST',
  path: '/v1/user-emails',
  params: z.object({}),
  query: z.object({}),
  body: CreateUserEmailBodySchema,
  response: z.object({ data: UserEmailSchema }),
  successStatus: 201,
});
